import { Component, computed, inject, input, signal } from '@angular/core';
import { NodeCoper } from '@app/models/entity.model';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { MediaComponent } from '@app/components/media/media.component';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { TextComponent } from '@app/components/text/text.component';
import { TextsPipe } from '@app/pipes/texts.pipe';
import { IconLinkComponent } from '@app/components/person/icon-link/icon-link.component';
import { FileDownloadComponent } from '@app/components/file-download/file-download.component';
import { CardComponent } from '@app/components/card/card.component';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { DrupalService } from '@app/services/drupal.service';
import { DataService } from '@app/services/data.service';
import { ViewComponent } from '@app/components/view/view.component';
import { MobiLdSchemaComponent } from '@app/components/mobi-ld-schema/mobi-ld-schema.component';

@Component({
  selector: 'mobi-node-coper',
  templateUrl: './node-coper.component.html',
  styleUrls: ['./node-coper.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    BreadcrumbComponent,
    MediaComponent,
    ContentSectionComponent,
    TextComponent,
    TextsPipe,
    IconLinkComponent,
    FileDownloadComponent,
    CardComponent,
    ViewComponent,
    MobiLdSchemaComponent,
  ],
})
export class NodeCoperComponent {
  readonly entity = input.required<NodeCoper>();
  hideGuides = signal(false);
  #drupal = inject(DrupalService);
  #data = inject(DataService);

  personSchema = computed(() => {
    return {
      '@context': 'https://schema.org',
      '@type': 'ProfilePage',
      mainEntity: {
        '@type': 'Person',
        email: this.entity()?.email || '',
        jobTitle: this.entity().function || '',
        name: this.entity().title,
        knowsLanguage: this.entity().languages,
        memberOf: [
          {
            '@type': 'Organization',
            name: this.#data.orgNames[this.#drupal.language()],
          },
        ],
        worksFor: [
          {
            '@type': 'Organization',
            name: this.#data.orgNames[this.#drupal.language()],
          },
        ],
      },
    };
  });
}
